import { Box, Stack } from '@mui/material';

import type { SegmentedProgressBarProps } from '../SegmentedProgressBar.types';
import useStyles from './SegmentedProgressBarLegend.styles';

const SegmentedProgressBarLegend = ({
  data
}: {
  data: SegmentedProgressBarProps[];
}) => {
  const { classes } = useStyles();

  return (
    <Stack
      className={classes.stack}
      direction="row"
      sx={{ display: 'flex', justifyContent: 'space-evenly' }}
      spacing={2}
    >
      {data.map((item: SegmentedProgressBarProps) => {
        return (
          <Box key={item.name} className={classes.containerBox}>
            <Box
              className={classes.colorBox}
              sx={{
                backgroundColor: item.color
              }}
            />
            <Stack direction="column" sx={{ display: 'flex' }}>
              <span className={classes.totalText}>{item.data[0]}</span>
              <span className={classes.labelText}>{item.name}</span>
            </Stack>
          </Box>
        );
      })}
    </Stack>
  );
};

export default SegmentedProgressBarLegend;
